import React, {
  useImperativeHandle,
  useRef,
  MutableRefObject,
} from 'react';
import { useCollapsibleScene } from 'react-native-collapsible-tab-view';

export interface ICollapsibleTabListSceneProps {
  name: string;
  children: React.ReactElement;
  listRef?: MutableRefObject<any>;
}

export function CollapsibleTabListScene({
  name,
  children,
  listRef,
}: ICollapsibleTabListSceneProps) {
  const innerRef = useRef(null);
  const { ref, ...sceneProps } = useCollapsibleScene(name);

  useImperativeHandle(listRef, () => {
    ref(innerRef);
    return innerRef.current;
  });

  return React.cloneElement(children, {
    animated: true,
    listRef: innerRef,
    ...sceneProps,
  });
}
